import NewClientModal from "./NewClientModal";
import React, { useEffect, useState, useRef } from "react";
import unsplash from "../api/unsplash";
import { useNavigate } from "react-router-dom";

import {
  Checkbox,
  InputAdornment,
  FormControlLabel,
  Box,
  IconButton,
  Alert,
  Button,
  Select,
  OutlinedInput,
  MenuItem,
  FormControl,
  Card,
  Grid,
  CardContent,
  ButtonGroup,
  Tooltip,
  LinearProgress,
  Snackbar,
} from "@mui/material";
import {
  DataGridPro,
  GridToolbar,
  itIT,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
  GridToolbarQuickFilter,
  GridFooterContainer,
} from "../utils/PersistedDataGridPro";
import { CustomFooterPersonalized } from "../utils/CustomFooterPersonalized";
import { createClientiExportWorkbook } from "../utils/clientiExcel";
import { saveAs } from "file-saver";
import {
  Circle,
  HealthAndSafety,
  Search,
  MenuBook,
  FiberNew,
  InsertDriveFile,
} from "@mui/icons-material";
import GlobalSnackbar from "./Snackbar";

import Grow from "@mui/material/Grow";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuList from "@mui/material/MenuList";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Excel } from "../utils/Excel";
import { createPortal } from "react-dom";

const Clienti = ({ screenSize }) => {
  const [clienti, setClienti] = useState([]);
  const [utenti, setUtenti] = useState([]);
  const [test, setTesto] = useState(false);
  const [clientiVisibili, setClientiVisibili] = useState([]);
  const [loading, setLoading] = useState(true);
  const [valueFilter, setValueFilter] = useState("");
  const [soloSenzaCodiceAgo, setSoloSenzaCodiceAgo] = useState(false);

  const anchorRef = useRef(null);
  const [openButton, setOpenButton] = useState(false);

  const navigate = useNavigate();
  const [openSnack, setOpenSnack] = useState(false);
  const [filtro, setFiltro] = useState({
    medicina: true,
    cessati: false,
    attivi: true,
  });

  const [snack, setSnack] = useState({
    severity: "success",
    messaggio: "Salvataggio Effettuato correttamente",
    open: false,
  });

  const columns = [
    {
      filterable: false,
      field: "new",
      headerName: "",
      width: 10,
      headerAlign: "center",
      align: "center",
      sort: "asc",
      renderCell: (
        params, //mi aiuta a mettere il valore
      ) => (
        <>
          {params.row.new ? (
            <FiberNew
              sx={{ color: "#40C18F", width: "25px", height: "25px" }}
            />
          ) : (
            ""
          )}
        </>
      ),
    },
    {
      filterable: false,
      field: "Cessato",
      headerName: "Stato",
      //width: 400,
      width: screenSize < "768" ? 50 : 70,
      headerAlign: "center",
      align: "center",
      sort: "asc",
      renderCell: (params) => (
        <>
          {params.row.Cessato === 1 ? (
            <Tooltip title="Cessato">
              <Circle
                sx={{ color: "#FF2768", width: "15px", height: "15px" }}
              />
            </Tooltip>
          ) : (
            <Tooltip title="Attivo">
              <Circle
                sx={{ color: "#40C18F", width: "15px", height: "15px" }}
              />
            </Tooltip>
          )}
        </>
      ),
    },

    {
      field: "RagioneSociale",
      headerName: "Ragione Sociale",
      width: 150,
      flex: screenSize < "768" ? 0 : 1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
    {
      field: "CodiceAgo",
      headerName: "Codice Ago",
      width: 140,
      type: "string",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "PIVA",
      headerName: "Partita IVA",
      width: 150,
      flex: screenSize < "768" ? 0 : 1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
    {
      field: "SedeIndirizzo",
      headerName: "Indirizzo",
      width: 150,
      flex: screenSize < "768" ? 0 : 1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
    {
      field: "SedeLocalita",
      headerName: "Località",
      width: 150,
      flex: screenSize < "768" ? 0 : 1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
    {
      field: "SedeCAP",
      headerName: "Cap",
      width: 150,
      flex: screenSize < "768" ? 0 : 1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
  ];
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
  };

  const handleToggleButton = () => {
    setOpenButton(!openButton);
  };
  const handleCloseButton = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpenButton(false);
  };

  const handleExportClientiAttivi = async () => {
    try {
      const workbook = createClientiExportWorkbook(
        clienti,
        utenti,
        soloSenzaCodiceAgo,
      );
      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(
        new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        "Esportazione Clienti.xlsx",
      );
    } catch {
      setSnack({
        severity: "error",
        messaggio: "Errore durante l'esportazione Excel",
      });
      setOpenSnack(true);
    }
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <Grid
          container
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
          sx={{ columnGap: 2, margin: { xs: 2, md: 1 } }}
        >
          <GridToolbarQuickFilter placeholder="Cerca..." />
          <FormControlLabel
            sx={{
              marginBottom: "0px!important",
              fontSize: "13px!important",
              color: "#11526F",
            }}
            control={
              <Checkbox
                size="small"
                sx={{ fontSize: "13px!important", color: "#11526F" }}
                checked={filtro.medicina}
                onClick={(e) => filter(e, "medicina")}
              />
            }
            label="Medicina"
          />
          <FormControlLabel
            sx={{
              marginBottom: "0px!important",
              fontSize: "13px",
              color: "#11526F",
            }}
            control={
              <Checkbox
                size="small"
                checked={filtro.attivi}
                onClick={(e) => filter(e, "attivi")}
              />
            }
            label="Attivi"
          />
          <FormControlLabel
            sx={{
              marginBottom: "0px!important",
              fontSize: "13px",
              color: "#11526F",
            }}
            control={
              <Checkbox
                size="small"
                checked={filtro.cessati}
                onClick={(e) => filter(e, "cessati")}
              />
            }
            label="Cessati"
          />
          <FormControlLabel
            label="Senza codice Ago"
            control={
              <Checkbox
                size="small"
                checked={soloSenzaCodiceAgo}
                onChange={(e) => setSoloSenzaCodiceAgo(e.target.checked)}
              />
            }
          />
          <Button
            startIcon={<InsertDriveFile />}
            style={{
              display: clienti.some((c) => c.Cessato !== 1) ? "" : "None",
            }}
            variant="text"
            size="small"
            onClick={handleExportClientiAttivi}
          >
            Esporta Excel
          </Button>
          <Excel
            requiredColumn={"RagioneSociale"}
            getAllTableData={"Clienti"}
            filterColumn={[
              "RagioneSociale",
              "SedeIndirizzo",
              "SedeLocalita",
              "SedeCAP",
            ]}
            //thereIsData={["DataDiNascita"]}
            excelHeader={[
              "RagioneSociale",
              "SedeIndirizzo",
              "SedeLocalita",
              "SedeCAP",
            ]}
            reloadData={async () => {
              let response = await unsplash.get("clienti", {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("jwt")}`,
                },
                params: { all: "yes" },
              });
              setClienti(response.data.data);
              setClientiVisibili(
                response.data.data.filter((c) => c.Cessato !== 1),
              );
            }}
            fileName={"Clienti"}
            handleSave={async (importedData) => {
              try {
                await unsplash.post(
                  "excel",
                  {
                    excel: importedData,
                    table: "Clienti",
                  },
                  {
                    headers: {
                      Authorization: `Bearer ${localStorage.getItem("jwt")}`,
                    },
                  },
                );
              } catch {
                setSnack({
                  severity: "error",
                  messaggio: "Errore durante l'importazione",
                });
                setOpenSnack(true);
              }
            }}
          />
        </Grid>
      </GridToolbarContainer>
    );
  }

  const filter = (e, tipologia) => {
    let f = { ...filtro };
    f[tipologia] = e.target.checked;
    setFiltro(f);

    let clientiTemp = clienti;

    var clientiX = []; // popolo l'array
    var i;
    for (i = 0; i < clienti.length; i++) {
      if (
        [clienti[i].RagioneSociale, clienti[i].CodiceAgo].some((value) =>
          String(value || "")
            .toLowerCase()
            .includes(valueFilter.toLowerCase()),
        )
      ) {
        clientiX.push(clienti[i]);
      }

      if (!f.medicina) {
        clientiX = clientiX.filter((c) => c.GestioneMedicina === 1);
      }

      if (!f.cessati) {
        clientiX = clientiX.filter((c) => c.Cessato !== 1);
      }

      if (!f.attivi) {
        clientiX = clientiX.filter((c) => c.Cessato !== 0);
      }
    }
    setClientiVisibili(clientiX);
  };

  //importante per l'api l'arrayvuoto
  const handleChange = (e) => {
    setValueFilter(e.target.value);
    // filtro

    //setFiltro({medicina:false});
    let arrayFiltrato = clienti;
    if (e.target.value == "") {
      if (!filtro.medicina) {
        arrayFiltrato = arrayFiltrato.filter((c) => c.GestioneMedicina === 1);
      }

      if (!filtro.cessati) {
        arrayFiltrato = arrayFiltrato.filter((c) => c.Cessato !== 1);
      }

      if (!filtro.attivi) {
        arrayFiltrato = arrayFiltrato.filter((c) => c.Cessato !== 0);
      }
      setClientiVisibili(arrayFiltrato);
    } else {
      var clientiX = []; // popolo l'array
      var i;
      for (i = 0; i < clienti.length; i++) {
        if (
          [clienti[i].RagioneSociale, clienti[i].CodiceAgo].some((value) =>
            String(value || "")
              .toLowerCase()
              .includes(e.target.value.toLowerCase()),
          )
        ) {
          clientiX.push(clienti[i]);
        }

        if (!filtro.medicina) {
          clientiX = clientiX.filter((c) => c.GestioneMedicina === 1);
        }

        if (!filtro.cessati) {
          clientiX = clientiX.filter((c) => c.Cessato !== 1);
        }

        if (!filtro.attivi) {
          clientiX = clientiX.filter((c) => c.Cessato !== 0);
        }
      }
      setClientiVisibili(clientiX);
    }
  };

  const handleSaveData = async (cliente) => {
    try {
      //AGGIUNGERE LA CREAZIONE DELLA SEDE
      let responseCliente = await unsplash.post(
        "clienti",
        { cliente: cliente },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
        },
      );

      cliente.new = true;
      cliente.ID = responseCliente.data.message.insertId;
      let c = [...clienti];
      c.unshift(cliente); //aggiungo in prima posizione

      setClienti(c);
      setClientiVisibili(c);

      let historySaved = true;
      await unsplash
        .post(
          "storico",
          {
            tabella: "Clienti",
            key: cliente.ID,
            utente: sessionStorage.getItem("username"),
            after: cliente,
            before: [],
            operazione: "Inserimento",
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("jwt")}`,
            },
          },
        )
        .catch(() => {
          // Il cliente esiste già: chiudere comunque la finestra.
          historySaved = false;
        });

      setSnack({
        severity: historySaved ? "success" : "warning",
        messaggio: historySaved
          ? "Cliente creato con successo"
          : "Cliente creato, ma registrazione nello storico non riuscita",
      });
      setOpenSnack(true);
      return true;
    } catch (error) {
      setSnack({
        severity: "error",
        messaggio: "Errore durante la creazione del Cliente",
      });
      setOpenSnack(true);
      return false;
    }
  };

  useEffect(() => {
    // è un loop qui carico i dati
    const fetchData = async () => {
      try {
        let response = await unsplash.get("clienti", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
          params: { all: "yes" },
        });
        setClienti(response.data.data);
        setClientiVisibili(response.data.data.filter((c) => c.Cessato !== 1));
        let responseUtenti = await unsplash.get("utenti", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
        });
        setUtenti(responseUtenti.data.data);
        setLoading(false);
      } catch (error) {
        console.error(error.message);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {}, [screenSize]);

  return (
    <>
      {" "}
      <GlobalSnackbar
        severity={snack.severity}
        messaggio={snack.messaggio}
        openSnack={openSnack}
        handleCloseSnack={handleCloseSnack}
      />
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <div>
              <Grid
                container
                direction="row"
                spacing={2}
                alignItems="center"
                justifyContent="flex-end"
              >
                <Grid item xs={12} md={4}>
                  <Grid
                    container
                    direction="row"
                    alignItems="center"
                    justifyContent="flex-end"
                  >
                    <ButtonGroup
                      variant="contained"
                      aria-label="outlined primary button group"
                    >
                      <Button
                        className="ButtonMiller"
                        startIcon={<MenuBook />}
                        onClick={() => navigate("/ProceduraGuidata")}
                      >
                        Procedura Guidata
                      </Button>
                      <NewClientModal myFunction={handleSaveData} />
                    </ButtonGroup>
                  </Grid>
                </Grid>
              </Grid>

              <Box
                sx={{
                  height: { xs: "75vh", md: "60vh", xl: "75vh" },
                  width: 1,
                }}
              >
                <DataGridPro
                  sx={{ fontSize: 12 }}
                  components={{
                    Toolbar: CustomToolbar,
                    Footer: CustomFooterPersonalized,
                  }}
                  slots={{
                    loadingOverlay: LinearProgress,
                  }}
                  loading={loading}
                  localeText={
                    itIT.components.MuiDataGrid.defaultProps.localeText
                  }
                  pagination={false}
                  rows={clientiVisibili.filter(
                    (c) => !soloSenzaCodiceAgo || !c.CodiceAgo?.trim(),
                  )}
                  columns={columns}
                  getRowId={(row) => row.ID}
                  pageSize={100}
                  initialState={{
                    sorting: {
                      sortModel: [{ field: "matricola", sort: "desc" }],
                    },
                    pinnedColumns: { left: ["Cessato"] },
                  }}
                  disableSelectionOnClick
                  onRowClick={async (params, event) => {
                    let idCliente = params.row.ID;
                    let ragSoc = params.row.RagioneSociale;

                    navigate("/dettaglioCliente", {
                      state: { idC: idCliente, RagioneSociale: ragSoc },
                    });
                  }}
                />
              </Box>
            </div>
          </CardContent>
        </Card>
      </Grid>
    </>
  );
};

export default Clienti;
